export default __webpack_public_path__ + "static/media/highlights-of-the-regional.74cf2db3.jpg";